import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { getDeliveryMethods } from '../store/reducers';
import SelectField from "./form-fields/SelectField";
import { useFormContext } from "react-hook-form";


const DeliveryMethod = ({ fetchDeliveryMethods, deliveryMethods, isDisabled, onSelect }) => {

  const form = useFormContext();

  useEffect(() => {
    fetchDeliveryMethods();  
  }, [fetchDeliveryMethods]);
     
  const deliveryMethodOptions = deliveryMethods ? deliveryMethods.map(method => ({
        value: method.Id,
        label: `${method.Name} - $${method.Fee}`
    })) : [];

    useEffect(() => {
      if (deliveryMethodOptions.length && !form.getValues('deliveryMethod')) {
        form.setValue('deliveryMethod', deliveryMethodOptions[0].value);
      }
    }, [deliveryMethodOptions]); // eslint-disable-line
    
    useEffect(() => {
      if (isDisabled) {
        form.setValue('deliveryMethod', deliveryMethodOptions[0].value);
      }
    }, [isDisabled]); // eslint-disable-line

    return (
      <SelectField
        name="deliveryMethod"
        control={form.control}
        disabled={isDisabled}
        controlId="deliveryMethodSelect"
        onChangeCallBack={onSelect}
      >
        {deliveryMethodOptions.map((option, index) => (
          <option key={index} value={option.value}>
            {option.label}
          </option>
        ))}
      </SelectField>
    );
};

function mapStateToProps({ deliveryMethods }) {
  return {
    deliveryMethods
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchDeliveryMethods: () => dispatch(getDeliveryMethods())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DeliveryMethod);

